import React, { useEffect, useState } from 'react';
import { Grid } from '@mui/material';
import { useParams } from 'react-router-dom';
import { useGlobalProperty } from 'models/globalPropertyContext';
import { useThemeBreakpoint } from 'hooks/useThemeBreakpoint';
import { Table } from 'components/molecules/Table';
import { CardList } from 'components/molecules/CardList';
import { Pagination } from 'components/molecules/Pagination';
import { Loader } from 'components/atoms/Loader';
import { EPerPages, ESortDirectionTypes, ISortOptions } from 'models/table';
import { historyTableColumns, mapHistoryToDataSource } from '../../helpers';
import { useCase } from '../../hooks';
import { HistoryTableCard } from '../HistoryTableCard';

const History = () => {
  const { caseId = '' } = useParams<{ caseId: string }>();
  const { isDesktop } = useThemeBreakpoint();
  const { longDateFormat, getProperties } = useGlobalProperty();
  const { getHistoryData, history, paginatorHistory } = useCase();
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [perPage, setPerPage] = useState<EPerPages>(EPerPages.perPage25);
  const [sort, setSort] = useState<ISortOptions | null>({
    property: 'createdDate',
    direction: ESortDirectionTypes.DESC,
  });
  const [isLoading, setIsLoading] = useState(true);
  const [isPaginationLoading, setIsPaginationLoading] = useState(false);

  useEffect(() => {
    getProperties();
  }, []);

  useEffect(() => {
    (async () => {
      setIsPaginationLoading(true);
      if (!history.length) {
        setIsLoading(true);
      }
      await getHistoryData(caseId, currentPage, perPage, sort);
      setIsLoading(false);
      setIsPaginationLoading(false);
    })();
  }, [currentPage, perPage, sort]);

  return (
    <Grid sx={{ gap: "20px" }}>
      {isLoading ? (
        <Grid size={{ xs: 12 }}>
          <Loader isLoading />
        </Grid>
      ) : (
        <>
          {isDesktop ? (
            <Table
              columns={historyTableColumns()}
              dataSource={mapHistoryToDataSource(history, longDateFormat)}
              onSort={setSort}
              defaultSort={sort || undefined}
              id="history_list-table"
            />
          ) : (
            <CardList
              items={mapHistoryToDataSource(history, longDateFormat)}
              render={(data, index) => <HistoryTableCard data={data} key={index} />}
            />
          )}
          {paginatorHistory && (
            <Pagination
              count={paginatorHistory.totalElements}
              onChangePage={(page) => setCurrentPage(page)}
              current={currentPage}
              perPage={perPage}
              onChangePerPage={(value) => setPerPage(value)}
              isLoading={isPaginationLoading}
            />
          )}
        </>
      )}
    </Grid>
  );
};

export default History;
